import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ClaimService } from '../claim.service';
import { CrawfordSnackbarService, ITabComponent, CrawfordSpinnerService } from 'crawford-shell';
import { ClaimAdjusterInfo } from '../model/claim-adjuster-info.model';
import { global } from '../../app.settings';

@Component({
  selector: 'app-claim-adjuster-info',
  templateUrl: './claim-adjuster-info.component.html',
  styleUrls: ['./claim-adjuster-info.component.scss']
})
export class ClaimAdjusterInfoComponent implements OnInit, ITabComponent {

  @Input() crawfordRef: string;
  @Input() source: string;

  public adjusterInfoGroup: FormGroup;
  private dataLoaded = false;

  constructor(
    private claimService: ClaimService,
    private formBuilder: FormBuilder,
    private spinnerService: CrawfordSpinnerService,
    private snackbarService: CrawfordSnackbarService
  ) { }

  loadData(): void {
    if (!this.dataLoaded) {
      this.spinnerService.show('claimAdjusterInfoSpinner');
      if (this.crawfordRef) {
        this.claimService.getClaimAdjusterInfo(this.crawfordRef, this.source).subscribe(
          adjusterInfo => {
            if (adjusterInfo) {
              this.adjusterInfoGroup.setValue(adjusterInfo);
            } else {
              this.snackbarService.displayErrorMessage('No adjuster info for this claim');
            }
            this.spinnerService.hide('claimAdjusterInfoSpinner');
          },
          error => {
            this.spinnerService.hide('claimAdjusterInfoSpinner');
          }
        );
      }
    }
  }

  ngOnInit() {
    this.adjusterInfoGroup = this.formBuilder.group({
      leadAdjuster: '',
      leadTechnician: '',
      fileLocation: ''
    });

    this.adjusterInfoGroup.disable();
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/claim/claim-adjuster-info/claim-adjuster-info.component.ts